import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
})
export class ShareModalComponent  implements OnInit {
  @Input() refreshMyData?: () => Promise<void>;

  /**
   * Estado de progresso do share. Quando true:
   *  - botao mostra spinner + texto "Gerando..."
   *  - botao fica disabled (anti double-tap)
   *  - icone X de close some (pra usuario nao cancelar no meio)
   * Modal so dispensa apos refreshMyData resolver, garantindo que o feedback
   * visual fica ate o ultimo ms antes do Share.share() nativo abrir.
   */
  public sharing = false;

  constructor(private modalCtrl: ModalController,
              private translate: TranslateService
  ) { }

  ngOnInit() {}

  // Fechar modal — bloqueado durante share em andamento.
  dismiss() {
    if (this.sharing) return;
    this.modalCtrl.dismiss();
  }

  async triggerShare() {
    if (this.sharing) return;
    if (!this.refreshMyData) {
      await this.modalCtrl.dismiss();
      return;
    }
    this.sharing = true;
    try {
      await this.refreshMyData();
    } catch (e) {
      console.warn('triggerShare error:', e);
    } finally {
      this.sharing = false;
      try {
        await this.modalCtrl.dismiss();
      } catch (_) { /* modal pode ter sido dispensado externamente */ }
    }
  }

}
